/**
 * Text Formatting Utilities
 * 
 * Utility functions for consistent text formatting across the application
 */

/**
 * Formats a title by keeping the first word capitalized and lowercasing the rest
 * @param {string} title - The title to format
 * @returns {string} - The formatted title
 */
export const formatTitle = (title) => {
  if (!title || typeof title !== 'string') {
    return title;
  }
  
  const words = title.split(' ');
  if (words.length === 0) {
    return title;
  }
  
  // Keep first word as is, lowercase the rest
  return words.map((word, index) => {
    if (index === 0) {
      return word; // Keep first word unchanged
    }
    return word.toLowerCase();
  }).join(' ');
};

/**
 * Formats founder type titles specifically
 * Examples: "The Visionary" -> "The visionary", "The Relationship Builder" -> "The relationship builder"
 * @param {string} founderTitle - The founder type title to format
 * @returns {string} - The formatted founder type title
 */
export const formatFounderTitle = (founderTitle) => {
  return formatTitle(founderTitle);
};

/**
 * Formats section headings consistently
 * @param {string} heading - The heading to format
 * @returns {string} - The formatted heading
 */
export const formatSectionHeading = (heading) => {
  return formatTitle(heading);
};

const textUtils = {
  formatTitle,
  formatFounderTitle,
  formatSectionHeading
};

export default textUtils;
